"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointHelper = void 0;
var envConfig_1 = require("../envConfig");
var Page_helper_1 = require("./Page.helper");
var environment_helper_1 = require("./environment.helper");
exports.EndpointHelper = {
    completePath: function (path) {
        return "/".concat(path).replace("//", "/");
    },
    getHostEndpoint: function (path, searchParamsObj) {
        if (path === void 0) { path = ""; }
        if (searchParamsObj === void 0) { searchParamsObj = {}; }
        var url = "".concat(envConfig_1.COMMON_ENV_CONFIG.HOST_ENDPOINT).concat(this.completePath(path));
        return this.getEndpoint(url, searchParamsObj);
    },
    getCMSProxyEndpoint: function (path, searchParamsObj, isPrivate) {
        if (path === void 0) { path = ""; }
        if (searchParamsObj === void 0) { searchParamsObj = {}; }
        if (isPrivate === void 0) { isPrivate = false; }
        var url = "";
        if (environment_helper_1.EnvironmentHelper.isServerSide()) {
            url = "".concat(envConfig_1.COMMON_ENV_CONFIG.CMS_PROXY_NO_APIC_ENDPOINT).concat(this.completePath(path));
        }
        else if (Page_helper_1.PageHelper.isHCLAuthoringPage() &&
            !Page_helper_1.PageHelper.isStaticFilePage()) {
            url = "/api/:api_type/cms-proxy".concat(this.completePath(path));
        }
        else {
            url = "".concat(envConfig_1.COMMON_ENV_CONFIG.CMS_PROXY_ENDPOINT).concat(this.completePath(path));
        }
        url = url.replace("/:api_type/", isPrivate ? "/priv/" : "/pub/");
        return this.getEndpoint(url, searchParamsObj);
    },
    getEndpoint: function (url, searchParamsObj) {
        var searchParamsEntries = Object.entries(searchParamsObj).filter(function (_a) {
            var _ = _a[0], value = _a[1];
            return typeof value !== null && typeof value !== "undefined";
        });
        if (searchParamsEntries.length > 0) {
            return (url +
                "?" +
                searchParamsEntries
                    .reduce(function (searchParams, _a) {
                    var key = _a[0], value = _a[1];
                    searchParams.append(key, "".concat(value));
                    return searchParams;
                }, new URLSearchParams())
                    .toString());
        }
        else {
            return url;
        }
    },
};
